@if (isMenu) {
  <button mat-menu-item [attr.aria-label]="'restoreFromArchive' | translate">
    <mat-icon>assignment_turned_in</mat-icon>
    {{ 'restoreArchive' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'restoreFromArchive' | translate"
    matTooltip="{{ 'restoreFromArchive' | translate }}">
    <mat-icon>assignment_turned_in</mat-icon>
  </button>
}
